export default {
  GET_HOMEWORK_TITLE: 'GET_HOMEWORK_TITLE',
  GET_HOMEWORK_BLOCKS: 'GET_HOMEWORK_BLOCKS',
  GET_HOMEWORK_ERROR: 'GET_HOMEWORK_ERROR',

  START_FETCHING_HOMEWORK: 'START_FETCHING_HOMEWORK',
  STOP_FETCHING_HOMEWORK: 'STOP_FETCHING_HOMEWORK',
};